import { useState, useEffect } from 'react';
import IPDService from '../services/ipdService';

const ipdService = new IPDService();

const useGetPatientTimeline = (patientId) => {
    const [timeline, setTimeline] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTimeline = async () => {
        if (!patientId) return;

        setLoading(true);
        setError(null);
        try {
            const patientData = await ipdService.getPatientById(patientId);
            setTimeline(patientData.timeline || []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTimeline();
    }, [patientId]);

    return {
        timeline,
        loading,
        error,
        refetch: fetchTimeline
    };
};

export default useGetPatientTimeline; 